import React from 'react';
import {useIsLightTheme} from 'epic-ue-theme';
import {LoadingWrap, LoadingWrapProps} from './LoadingWrap';
import * as lightAnimationData from './lottie/ue-loader-light.json';
import * as darkAnimationData from './lottie/ue-loader-dark.json';
import Lottie from 'react-lottie';

export const UnrealLoading = (props: LoadingWrapProps): JSX.Element => {
    const isLight = useIsLightTheme();
    return (
        <LoadingWrap {...props}>
            <Lottie
                options={{
                    animationData: isLight ? lightAnimationData : darkAnimationData
                }}
            />
        </LoadingWrap>
    );
};
